<template>
<div>
    <HeaderMember header="เพิ่มพนักงาน" :img_header="header_image" link_back="admin" />
    <AddAdminList />
</div>
</template>

<script>
import HeaderImage from '@/assets/add-friend.png'
import HeaderMember from '@/components/admin/member/headermember/HeaderMember.vue'
import AddAdminList from '@/components/admin/member/admin/AddAdminList.vue'

export default {
    name: 'addAdmin',
    components: {
        HeaderMember,
        AddAdminList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
